import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

export interface EditCardEditorButtonProps {
  /** URL to open the edit in the external video editor. */
  editorUrl: string;
}

/**
 * Link-style control that opens the video editor for this edit.
 */
export function EditCardEditorButton({ editorUrl }: EditCardEditorButtonProps) {
  const { $t } = useIntl();

  return (
    <Button
      component="a"
      href={editorUrl}
      rel="noopener noreferrer"
      size="small"
      variant="text"
      startIcon={<EditIcon fontSize="small" />}
    >
      {$t({
        id: 'common.edit',
        defaultMessage: 'Editar',
      })}
    </Button>
  );
}
